import { defineCustomElement } from 'vue'
import App from '@/App.ce.vue'
;(() => {
  const Element = defineCustomElement(App)
  customElements.define('remote-diagnose', Element)
})()
